var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfIcon = function SvgPdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "pdf-icon_svg__Capa_2",
    viewBox: "0 0 112.84 127.16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-icon_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.81.5H23.2c-3.87 0-7.01 3.14-7.01 7.01v112.14c0 3.87 3.14 7.01 7.01 7.01h82.13c3.87 0 7.01-3.14 7.01-7.01V35.03z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.81 1v34.03h34",
    fill: "#ebf0fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.01 0H23.2c-4.14 0-7.51 3.37-7.51 7.51v112.14c0 4.14 3.37 7.51 7.51 7.51h82.13c4.14 0 7.51-3.37 7.51-7.51V34.83zm.29 1.71 32.83 32.83H78.3zm33.53 117.94c0 3.59-2.92 6.51-6.51 6.51H23.2c-3.59 0-6.51-2.92-6.51-6.51V7.51C16.69 3.92 19.61 1 23.2 1h54.11v34.53h34.5v-.32l.03.03v84.41Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 95.95,
    height: 47.98,
    y: 59.53,
    rx: 4.24,
    ry: 4.24,
    fill: "#e55240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.22 87.23v8.43h-4.45V71.71h7.8c1.6 0 2.99.19 4.16.56 1.17.38 2.14.9 2.9 1.57s1.33 1.48 1.69 2.42.55 1.97.55 3.08-.19 2.22-.58 3.19q-.585 1.455-1.74 2.49c-.77.7-1.74 1.24-2.9 1.62-1.16.39-2.52.58-4.07.58h-3.35Zm0-3.48h3.35c.82 0 1.53-.1 2.14-.31.61-.2 1.11-.5 1.51-.88s.7-.84.89-1.39q.3-.825.3-1.83c0-1.005-.1-1.22-.3-1.74s-.5-.96-.89-1.32-.9-.64-1.51-.84c-.61-.19-1.32-.29-2.14-.29h-3.35v8.59ZM59.59 83.69c0 1.76-.29 3.37-.88 4.84-.58 1.47-1.41 2.73-2.47 3.79s-2.33 1.88-3.83 2.47c-1.49.59-3.14.88-4.95.88h-9.14V71.72h9.14c1.81 0 3.46.3 4.95.89s2.77 1.41 3.83 2.47c1.06 1.05 1.88 2.32 2.47 3.78s.88 3.08.88 4.84Zm-4.55 0c0-1.31-.18-2.49-.53-3.54-.35-1.04-.86-1.93-1.51-2.65s-1.44-1.28-2.38-1.66c-.93-.39-1.98-.58-3.15-.58h-4.65v16.86h4.65c1.17 0 2.22-.19 3.15-.58s1.73-.94 2.38-1.66 1.15-1.61 1.51-2.65c.35-1.04.53-2.22.53-3.54M78.18 71.71v3.54H67.56v7.09h8.96v3.56h-8.96v9.75h-4.49V71.7h15.1Z",
    fill: "#f2f2f2"
  }))));
};
export default SvgPdfIcon;